import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import FixButton from "../../widgets/Button";
import Utils from "../../utils/utils";
import ImageSilentInput from "../../widgets/ImageSilentInput";
import getCategorieCorsi from "../../services/getCategorieCorsi";
import SelectInput from "../../widgets/SelectInput";
import addSconto from "../../services/addSconto";

export default class AddSconto extends React.Component {
  constructor(props) {
    super(props);

    this.startDateRef = React.createRef();

    this.state = {
      isLoading: false,
      categoria: [],
      categoriaSelezionate: "",
      desc: "",
      attachment: "",
      isMobile: window.innerWidth < 768,
    };

    this.pageTitle = "Crea nuovo sconto";
  }

  async reload() {
    this.setState({ isLoading: true });

    const cookies = new Cookies();
    let username = cookies.get("username", { path: "/" });
    let token = cookies.get("token", { path: "/" });

    this.categorieCorsi = await getCategorieCorsi(username, token);

    const corsi = this.categorieCorsi.map((categoeie) => ({
      label: categoeie.name,
      value: categoeie.id,
    }));

    this.setState({
      corsi,
      isLoading: false,
    });

    this.setState({ isLoading: false });
  }

  componentDidMount() {
    window.addEventListener("resize", () => this.manageResize());
    this.reload();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.manageResize());
  }

  manageResize() {
    if (window.innerWidth >= 768) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  lockedSaveSconto = Utils.disallowConcurrency(this.save.bind(this));

  handleCategoriaChange(selectedOptions) {
    const categoriaSelezionate = selectedOptions
      .map((option) => option.value)
      .join(";");

    this.setState({
      categoria: selectedOptions,
      categoriaSelezionate,
    });
  }

  render() {
    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              ...base,
              width: "100%",
              position: "relative",
              paddingTop: "20px",
              paddingBottom: "20px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle title={this.pageTitle} />

          <div
            style={{
              display: "flex",
              flexDirection: this.state.isMobile ? "column" : "row",
            }}
          >
            <div
              style={{
                flex: 1,
                marginRight: this.state.isMobile ? "0" : "20px",
              }}
            >
              <h3 style={{ marginBottom: 10 }}>Informazioni generali</h3>
              <div
                style={{
                  marginBottom: 10,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div>
                  <SelectInput
                    value={this.state.categoria}
                    name="Categoria"
                    hidable={false}
                    options={this.state.corsi}
                    isMulti={true}
                    onChange={(selectedOptions) =>
                      this.handleCategoriaChange(selectedOptions)
                    }
                  />
                </div>
              </div>
              <textarea
                placeholder="Inserisci una descrizione dello sconto..."
                style={{
                  resize: "none",
                  width: "70%",
                  height: 100,
                  marginTop: 20,
                  padding: 10,
                  borderRadius: 5,
                }}
                onChange={(e) => this.setState({ desc: e.target.value })}
              />
              <ImageSilentInput
                name={
                  this.state.attachment ? "Pdf selezionato" : "Aggiungi pdf"
                }
                key={Math.random()}
                value={this.state.attachment}
                onChange={async (base64) => {
                  this.setState({ attachment: base64 });
                }}
              />
            </div>
          </div>

          <br />

          <FixButton
            title="Salva"
            callback={this.state.isLoading ? () => {} : this.lockedSaveSconto}
          />
        </LoadingOverlay>
      </>
    );
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    if (this.state.categoriaSelezionate == "") {
      alert("Seleziona almeno una categoria");
      return;
    }

    if (this.state.desc == "") {
      alert("Inserisci una descrizione");
      return;
    }

    this.setState({ isLoading: true });

    let sconto = {
      categoria: this.state.categoriaSelezionate,
      desc: this.state.desc,
      attachment: this.state.attachment,
    };

    let ret = await addSconto(username, token, sconto);

    if (ret.result == "ok") {
      cookies.set("currentSconto", ret.id, { path: "/" });
      this.setState({ isLoading: false });
      window.location.href = "/#/app/sconti";
    } else {
      this.setState({ isLoading: false });
      alert(
        "Si è verificato un errore inatteso durante la creazione dello sconto. Per favore, riprova."
      );
    }
  }
}
